import { render, staticRenderFns } from "./RecaptchaEnterprise.vue?vue&type=template&id=23043520"
import script from "./RecaptchaEnterprise.vue?vue&type=script&lang=ts"
export * from "./RecaptchaEnterprise.vue?vue&type=script&lang=ts"
import style0 from "./RecaptchaEnterprise.vue?vue&type=style&index=0&id=23043520&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports